module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_j_normal.30bb11a8.png";